<template>
    <div
        class="clean-input"
        ref="editable"
        contenteditable
        v-on="listeners"
        :placeholder="placeholder"
        v-bind:class="hasError ? 'is-invalid' : ''"
        @keydown.enter.prevent
    />
</template>

<script>
export default {
    name: "CleanInput",
    props: {
        value: {
            type: String,
            default: '',
        },
        placeholder: {
            type: String,
            default: ''
        },
        hasError: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        listeners() {
            return { ...this.$listeners, input: this.onInput };
        },
    },
    mounted() {
        this.$refs.editable.innerText = this.value;
    },
    methods: {
        onPaste(e) {
            // var text = this.decodeHTMLEntities(e.clipboardData.getData('text'));
            // text = text.replace(/<(.|\n)*?>/g, '');
            // text = text.replace(/^\s+|\s+$/gm,'');
            // console.log(text);
            // this.$refs.editable.innerText = text;
        },
        onInput(e) {
            var text = e.target.innerText;
            text = text.replace(/<(.|\n)*?>/g, '');
            text = text.replace(/^\s+|\s+$/gm,'');
            // this.$refs.editable.innerText = text;
            this.$emit('input', text);
        },
        decodeHTMLEntities (str) {
            const htmlEntities = {
                "&": "&amp;",
                "<": "&lt;",
                ">": "&gt;",
                '"': "&quot;",
                "'": "&apos;"
            };
            return str.replace(/([&<>\"'])/g, match => htmlEntities[match]);
        }
    }
}
</script>

<style scoped>
.clean-input.is-invalid {
    border-bottom: 1px solid #e3342f !important;
    white-space: pre-wrap;
}
[contenteditable][placeholder]:empty:before {
    content: attr(placeholder);
    position: absolute;
    color: gray;
    background-color: transparent;
}
</style>
